import { render } from "./StakeMintRedirectModal.vue?vue&type=template&id=4135f4d3&scoped=true"
import script from "./StakeMintRedirectModal.vue?vue&type=script&lang=ts"
export * from "./StakeMintRedirectModal.vue?vue&type=script&lang=ts"

import "./StakeMintRedirectModal.vue?vue&type=style&index=0&id=4135f4d3&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-4135f4d3"

export default script